import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useNavigate, useParams } from "react-router-dom";
import { createPageData, returnInwardFormData } from "./ReturnInwardFile";
import { LoaderCreatePage } from "../Loader/Loader";
import { formatNumber, getRecords, imageURL } from "../../services/api.service";
import "../../Style/hypperViewStyle.css";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";

const ReturnInwardView = ({ args }) => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint, referenceOptions } =
    createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(returnInwardFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedItems, setExpandedItems] = useState([]);
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  const [isModelOpen, setIsmodelOpen] = useState(false);
  const [groupedItems, setGroupedItems] = useState({});

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;

      const returnInwardItems =
        data?.return_inward_items &&
        data?.return_inward_items?.map((item) => ({
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.itemDetails?.item_code,
          buy_item_code: item?.buyItemDetails?.item_code,
          description: item?.buyItemDetails?.description,
          make_item_desc: item?.itemDetails?.description,
          uom: item?.buyItemDetails?.uom?.uom_name,
          make_item_uom: item?.itemDetails?.uom?.uom_name,
          stock_qty: item?.stock_qty,
          is_make_item: item?.is_make_item,
          return_qty: item?.return_qty,
          is_active: true,
          type: item?.type,
          id: item.uniqueId,
          is_show: false,
          make_buy_name: item?.is_make_item
            ? item?.buy_item_code + " (" + item?.item_code + ")"
            : item?.buy_item_code,
        }));
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          return_inward_items: returnInwardItems,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (Id) => {
    try {
      let payload = {
        modelName: "return_inwards",
        whereCondition: {
          id: Id,
        },
        relations: [
          {
            module: "return_inward_items",
            moduleAs: "return_inward_items",
            subModule: "item_masters",
            subModuleAs: "itemDetails",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "warehouse_masters",
            moduleAs: "warehouse",
          },
        ],
      };

      const responseData = await getRecords(payload, getEndpoint);
      if (responseData?.code == 1 && responseData?.data?.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleToggleItem = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // Filter items based on search query
  const filteredItems =
    formData?.inputData?.return_inward_items?.filter((item) =>
      item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);
  let serialNumber = 1;
  const FloatValue = (value) => {
    return parseFloat(value);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Return Inward Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            <Col md="6" className="">
                              <p onClick={() => setIsmodelOpen(true)}>
                                <strong>User: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                >
                                  {formData?.inputData.type === "Provision"
                                    ? "-"
                                    : formData?.inputData?.user?.first_name +
                                        " " +
                                        formData?.inputData?.user?.last_name ||
                                      "-"}
                                </span>
                              </p>
                              {isModelOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsmodelOpen(false)}
                                  id={formData?.inputData?.user?.id}
                                  type="user"
                                />
                              )}

                              <p>
                                <strong>Warehouse: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsWarehouseModalOpen(true)}
                                >
                                  {formData?.inputData?.warehouse
                                    ?.warehouse_name || "-"}
                                </span>
                              </p>
                              <p>
                                <strong>Type: </strong>
                                <span>{formData?.inputData?.type || "-"}</span>
                              </p>

                              {isWarehouseModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsWarehouseModalOpen(false)}
                                  id={formData?.inputData?.warehouse?.id}
                                  type="warehouse"
                                />
                              )}
                              <p>
                                <strong>Remark: </strong>
                                <span>
                                  {formData?.inputData?.remark || "-"}
                                </span>
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>

                          <div
                            id="table-container"
                            className="table mt-2"
                            style={{
                              overflow: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                            }}
                          >
                            <table
                              className="table table-hover"
                              style={{ tableLayout: "auto", minWidth: "100%" }}
                            >
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                }}
                              >
                                <tr
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1050,
                                    backgroundColor: "#8AC1E8",
                                    borderBottom: "1px solid black",
                                  }}
                                >
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "80px",
                                    }}
                                  >
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "120px",
                                    }}
                                  >
                                    Item Code
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "150px",
                                    }}
                                  >
                                    Item Description
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "80px",
                                    }}
                                  >
                                    UOM
                                  </th>

                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "100px",
                                    }}
                                  >
                                    Stock Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "120px",
                                    }}
                                  >
                                    return Inward Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      minWidth: "150px",
                                    }}
                                  >
                                    Type
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {Object.values(groupedItems).length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                ) : (
                                  Object.values(groupedItems)?.map(
                                    (group, index) => (
                                      <React.Fragment
                                        key={group.makeItem.unique_id}
                                      >
                                        {group?.makeItem?.is_make_item ==
                                          true && (
                                          <tr
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f0f8ff",
                                            }}
                                          >
                                            <td>{serialNumber++}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem?.item_code ||
                                                  "N/A"
                                                }
                                              >
                                                {group?.makeItem?.item_code ||
                                                  "N/A"}
                                              </div>
                                            </td>
                                            {/* <td>{"-"}</td> */}
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              {" "}
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem
                                                    ?.make_item_desc || "N/A"
                                                }
                                              >
                                                {group?.makeItem
                                                  ?.make_item_desc || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {" "}
                                              {group.makeItem.make_item_uom ||
                                                "N/A"}
                                            </td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                          </tr>
                                        )}
                                        {group?.buyItems
                                          ?.filter(
                                            (item) => item.is_make_item == true
                                          )
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{`${serialNumber - 1}.${
                                                subIndex + 1
                                              }`}</td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.buy_item_code || "N/A"
                                                  }
                                                >
                                                  {row?.buy_item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>

                                              <td>
                                                {formatNumber(row?.stock_qty) ||
                                                  "0"}
                                              </td>

                                              <td>{row?.return_qty || 0}</td>

                                              <td>
                                                {row?.type === 1
                                                  ? "Main"
                                                  : "Faulty"}
                                              </td>
                                            </tr>
                                          ))}
                                        {group?.buyItems
                                          ?.filter(
                                            (item) => item.is_make_item == false
                                          )
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{serialNumber++}</td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.item_code || "N/A"
                                                  }
                                                >
                                                  {row?.item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td>
                                                {formatNumber(row?.stock_qty) ||
                                                  "0"}
                                              </td>
                                              <td>
                                                {formatNumber(
                                                  row?.return_qty || "0"
                                                )}
                                              </td>
                                              <td>
                                                {row?.type == 1
                                                  ? "Main"
                                                  : "Faulty"}
                                              </td>{" "}
                                            </tr>
                                          ))}
                                      </React.Fragment>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReturnInwardView;
